import { getCspNonce } from '../../../utils/cspNonce';

export const loadApplePaySdk = (): Promise<void> => {
  return new Promise<void>((resolve, reject) => {
    const APPLE_PAY_SDK_URL = 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js';

    // Resolve immediately if the script is already loaded
    if (window.ApplePaySession) {
      return resolve();
    }

    const existingScript = document.querySelector(`script[src="${APPLE_PAY_SDK_URL}"]`);

    // If script tag exists, it might be loading; listen for it to finish.
    if (existingScript) {
      existingScript.addEventListener('load', () => resolve());
      existingScript.addEventListener('error', (e: Event) => reject(e));
      return;
    }

    // Otherwise, create and inject the script tag.
    const script = document.createElement('script');
    script.src = APPLE_PAY_SDK_URL;
    script.async = true;
    script.crossOrigin = 'true';
    script.nonce = getCspNonce();
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Apple Pay SDK failed to load'));
    document.head.appendChild(script);
  });
};

export const isApplePayAvailable = async (): Promise<boolean> => {
  try {
    await loadApplePaySdk();
    return !!(window.ApplePaySession && window.ApplePaySession.canMakePayments());
  } catch {
    console.warn('Apple Pay is not available');
    return false;
  }
};
